import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
import { PeakSource } from "./../../enums/enums";

class MerchantService {
  GetMerchantDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI.post("/api/Merchant/GetMerchantDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetMerchantRevenueDepartmentContact() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakTaxAPI
      .post("/api/Merchant/GetMerchantRevenueDepartmentContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  UpdateMerchantRevenueDepartmentContact(id: number) {
    const data = {
      contactId: id,
    };
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI
      .post("/api/Merchant/UpdateMerchantRevenueDepartmentContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoInsertMerchant(input: any) {
    const _input = {
      merchantId: 0,
      source: PeakSource.PeakTax,
      userName: input.userEmail,
      createMerchantModel: input.createMerchantModel,
      language: i18n.locale,
    };
    return service.peakRealTimeAPI.post("/api/Merchant/InsertMerchant", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetMerchantAddressList() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantAddressList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateMerchantDetail(merchant: any) {
    const _input = {
      merchantId: MerchantId(),
      merchant: merchant,
    };
    return service.peakRealTimeAPI.post("/api/Merchant/UpdateMerchant", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoVerificationMerchant(verificationMerchantModel: any) {
    const _input = {
      merchantId: MerchantId(),
      verificationMerchantModel: verificationMerchantModel,
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/VerificationOrganizationMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoVerificationMerchantByMatchLink(verificationMerchantModel: any) {
    const _input = {
      merchantId: MerchantId(),
      data: verificationMerchantModel,
    };
    return service.peakAppConnect
      .post("/api/MatchLink/VerificationMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateMerchantLogoAndStamp(updateMerchantLogoAndStamp: any) {
    const _input = {
      merchantId: MerchantId(),
      updateMerchantLogoAndStamp: updateMerchantLogoAndStamp,
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/UpdateMerchantLogoAndStamp", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoRefreshVerifiedStatus() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/RefreshVerifiedStatus", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetConnectPeakWithMerchantId() {
    const _input = {
      merchantId: MerchantId(),
      source: PeakSource.PeakTax,
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/GetConnectPeakWithMerchantId", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateConnectPeakWithMerchantId(input: any) {
    const _input = {
      merchantId: MerchantId(),
      isPeakPayrollConnected: input.isPeakPayrollConnected,
      isPeakTaxConnected: input.isPeakTaxConnected,
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/UpdateConnectPeakWithMerchantId", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetMerchantListByUserId(isUseMainDatabase = false) {
    const headers = SetHeaderService().headers;
    const params = { isUseMainDatabase: isUseMainDatabase };
    return service.peakRealTimeAPIForUser
      .get("/api/Merchant/GetMerchantListByUserId", { params, headers })
      .then((res) => {
        return res;
      });
  }
  DoGetSelectedMerchant(merchantId: number) {
    const headers = SetHeaderService().headers;
    const params = { merchantId: merchantId };
    return service.peakRealTimeAPIForUser.get("/api/Merchant/GetSelectedMerchant", { params, headers }).then((res) => {
      return res;
    });
  }
  DoGetFavoriteMerchant() {
    const _input = {};
    return service.peakExportAPI.post("/api/Merchant/GetFavoriteMerchant", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateFavoriteMerchant(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakExportAPI
      .post("/api/Merchant/UpdateFavoriteMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoDeleteFavoriteMerchant(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakExportAPI
      .post("/api/Merchant/DeleteFavoriteMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new MerchantService();
